module.exports = __webpack_public_path__ + "static/media/3.23febf75.jpg";